import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=1b707b02&"
import script from "./Contact.vue?vue&type=script&lang=js&"
export * from "./Contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b707b02')) {
      api.createRecord('1b707b02', component.options)
    } else {
      api.reload('1b707b02', component.options)
    }
    module.hot.accept("./Contact.vue?vue&type=template&id=1b707b02&", function () {
      api.rerender('1b707b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/LockerRoom/SubPages/Contact.vue"
export default component.exports